export default "__VITE_ASSET__BZp9lpt8__"